import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Assessment from '@material-ui/icons/Assessment';
import { CentralProviderSidebar, EXTERNAL_SITES, maestroApiCall } from '@michelin/central-provider';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';
import history from 'utils/history';
import { useUFOPaths } from 'utils/paths';
import { version } from '../../version.json';

const onSizeChange = () => {
  // This method was added to adjust the responsive dashboard to the new size
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 1000);
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerRoot: {
      marginTop: theme.spacing(2),
    },
  }),
);

export default function LeftNavigation() {
  const classes = useStyles();
  const { t } = useTranslation();
  const location = useLocation();
  const { PATH_ORDER_LIST_TO } = useUFOPaths();

  const activeMenu = location.pathname;

  const { data: backendVersion } = useQuery<{ version?: string }>(
    ['get-be-version'],
    () =>
      maestroApiCall({
        method: 'GET',
        endpoint: 'version',
        baseURL,
      }),
    {
      cacheTime: 3600,
    },
  );
  const versions: CentralProviderSidebar.Version[] = [
    {
      application: t('UI'),
      version: (version || '').split('-').pop() || '',
    },
    {
      application: t('API'),
      version: backendVersion?.version ? backendVersion.version.split('-').pop() || '' : ` ${t('loading...')}`,
    },
  ];

  const items: CentralProviderSidebar.Item[] = [
    {
      label: t('Dashboards'),
      icon: <Assessment color="primary" />,
      selected: activeMenu.includes('/order'),
      onClick: () => history.push(PATH_ORDER_LIST_TO),
    },
  ];

  return (
    <CentralProviderSidebar
      versions={versions}
      className={classes.drawerRoot}
      items={items}
      externalLinks={EXTERNAL_SITES}
      showCopyright
      onShrink={onSizeChange}
      onGrow={onSizeChange}
    />
  );
}
